import { getTenantByUrl } from "../api/users";

export default class TenantService {

  static async getDomain(ctx) {
    let wildcard;

    if (ctx && ctx.req) {
      wildcard = ctx.req.headers.host;
    } else {
      wildcard = window.location.hostname;
    }

    const domain = wildcard
      ? wildcard
      : false;

    if (domain === 'www') {
      return false;
    }

    return domain;
  }

  static applyStyle(currentTenant) {
    const style = document.createElement('style');
    if (currentTenant && currentTenant.primaryColor) {
      style.textContent = `

      .bg-primary-100 {
        background-color: ${this.darkColor(currentTenant.primaryColor)} !important;
      }

      .border-primary-400 {
        --border-opacity: 1;
        border-color: ${currentTenant.primaryColor};
      }

      .bg-primary-400 {
        --bg-opacity: 1;
        background-color: ${currentTenant.primaryColor};
      }

      .text-blue-400 {
        --text-opacity: 1;
        color: ${currentTenant.primaryColor};
      }

      .react-toggle--checked .react-toggle-thumb {
          left: 20px !important;
          --border-opacity: 1;
          border-color: ${currentTenant.primaryColor};
      }

      .react-toggle--checked .react-toggle-track {
        background-color: ${currentTenant.primaryColor};
      }
      
      .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
        background-color: ${currentTenant.secondaryColor};
      }

      .text-primary-400 {
        --text-opacity: 1;
        color: ${currentTenant.primaryColor};
      }

      .react-toggle--checked .react-toggle-track {
        --bg-opacity: 1;
        background-color: ${currentTenant.primaryColor};
    }

    .react-toggle--checked .react-toggle-track:hover {
      opacity: 0.5;
      background-color: ${currentTenant.primaryColor} !important;
    }

    .react-toggle-thumb:hover {
      opacity: 0.5;
      background-color: ${currentTenant.primaryColor} !important;
    }


    .bg-primary-700:hover {
      opacity: 1 ;
      color: white !important;
      background-color: ${currentTenant.primaryColor} !important;
    }

    .bg-primary-700 {
      opacity: 0.8 ;
      color: white !important;
      background-color: ${currentTenant.primaryColor} !important;
    }

    .bg-primary-400:hover {
      opacity: 0.5 ;
      color: white !important;
      background-color: ${currentTenant.primaryColor} !important;
      border-color: ${currentTenant.primaryColor};
    }

    .bg-primary-200:hover {
      opacity: 0.5 ;
      color: white !important;
      background-color: ${currentTenant.primaryColor} !important;
      border-color: ${currentTenant.primaryColor};
    }

    .border-blue-400 {
      border-left: 3px solid ${currentTenant.primaryColor} !important;
    }

    .primary-outlined:hover {
      opacity: 0.6 ;
      color: white !important;
      background-color: ${currentTenant.primaryColor} !important;
      border-color: ${currentTenant.primaryColor};
    }
    path:not(.grid-actions-delete path):not(.custom-alert-icon path):not(.custom-truck-icon path):not(.custom-box-icon path) {
      fill: ${currentTenant.secondaryColor} !important;
    }

    .grid-actions-delete path {
      fill: #EF4444 !important;
    }

    .custom-alert-icon path {
      fill: #ffe000 !important;
    }

    .custom-truck-icon path {
      fill: ${currentTenant.primaryColor} !important;
    }
    .custom-box-icon path {
      fill: ${currentTenant.primaryColor} !important;
    }
   

    
    `;
    }



    document.head.appendChild(style);

  }

  static async findTenantByUrl(domain) {
    let findCurrentTenant = await getTenantByUrl(domain);
    if (findCurrentTenant)
      return findCurrentTenant.tenantByDomains;
    else
      return null;
  }

  static darkColor(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);

    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;

    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }

    s = s * 100;
    s = Math.round(s);
    l = l * 40;
    l = Math.round(l);
    h = Math.round(360 * h);

    var colorInHSL = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    return colorInHSL;
  }

}